import React from 'react';
import './loginSelection.css'; // Import the CSS file for styling
import 'bootstrap/dist/css/bootstrap.min.css';
import { appConfig } from '../../utils/app.config';

const LoginSelection: React.FC = () => {
    return (
        <div className="login-selection-container container d-flex flex-column justify-content-center align-items-center vh-100">
            {/* Project name at the top */}
            <div className="login-text text-center mb-4">
                <h1 style={{color: "#552d62"}}>Login</h1> {/* Change "Project Name" to your actual project name */}
            </div>

            {/* Company logo in center */}
            <div className="company-logo-container text-center mb-4">
                <div className="company-logo">
                    <img src="static/img/logos/warwickBotlogo_final.png" alt="Company Logo" />
                </div>
            </div>

            {/* Separator with project name */}
            <div className="separator text-center separator-project">
                <h1 className="project-name">Itika Virtual Assistant</h1> {/* Change "Project Name" to your actual project name */}
            </div>

            {/* Service providers */}
            <div className="service-providers d-flex justify-content-around w-90 mt-4 w-100">
                {/* <div className="provider text-center">
                    <a href={`${appConfig.baseUrl}/auth/login/oauth2?provider=1&state=B0001`} className="provider-link">
                        <div className="provider-logo">
                            <img src="static/img/brand_logos/microsoft_black.svg" alt="Microsoft Logo" />
                        </div>
                        <p>Microsoft</p>
                    </a>
                </div>
                <div className="provider text-center">
                    <a href="https://www.google.com" className="provider-link">
                        <div className="provider-logo">
                            <img src="static/img/brand_logos/google_black.svg" alt="Google Logo" />
                        </div>
                        <p>Google</p>
                    </a>
                </div>
                <div className="provider text-center">
                    <a href="https://www.okta.com" className="provider-link">
                        <div className="provider-logo">
                            <img src="static/img/brand_logos/octa_black.svg" alt="Okta Logo" />
                        </div>
                        <p>Okta</p>
                    </a>
                </div> */}
                <div className="provider text-center w-100">
                    <a href={`${appConfig.baseUrl}`} className="provider-link w-100">
                        {/* <div className="provider-logo">
                            <img src="static/img/brand_logos/warwickBotlogoblack_final.svg" alt="PingID Logo" />
                        </div>
                        <p style={{ fontWeight: "bold" }}>Itika</p> */}
                        <button className="btn btn-lg btn-block sign-in-button w-50" style={{ backgroundColor: "#552d62", color: "#fff" }}>SignIn</button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default LoginSelection;
